import "../App.css";
import cloud1 from "../images/cloud1.svg";
import cloud2 from "../images/cloud2.svg";
import stars1 from "../images/stars1.svg";
import friend1 from "../images/Bear.png";
import friend2 from "../images/cat.png";

import { forwardRef } from "react";

function FAQ(props, ref) {
  return (
    <>
      <div
        ref={ref}
        class="tracks position-relative text-white text-center w-100 display-block"
      >
        <div class="content" style={{ top: "3vw" }}>
          <div class="text-center">
            <img src={friend1} class="img-fluid" style={{ maxWidth: "13%" }} />
          </div>
          <h1 style={{ fontSize: "4vw", fontWeight: "bold" }}>FAQ</h1>

          <div
            className="FAQ-container container fs-xs-5 fs-md-5 fs-lg-5"
            style={{ width: "100%" }}
          >
            <div className="row" id="FAQACCORDION">
              <div className="row">
                <div className="col-lg-6 col-md-6 mt-md-4 mx-auto">
                  <div>
                    <h2>General</h2>
                    <div>
                      <p>
                        <span
                          className="hover-text-bold cursor-pointer"
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseGeneralQuestion1"
                        >
                          What is a hackathon?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseGeneralQuestion1"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          A hackathon is a day-long event where attendees can:
                          compete for prize categories, attend workshops, and
                          participate in fun activities and games. Competing is
                          completely optional! You can also choose which
                          workshops/activities you want or don’t want to attend
                          based on your interests.
                        </div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseGeneralQuestion2"
                          className="cursor-pointer hover-text-bold"
                        >
                          Do I need to know how to code?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseGeneralQuestion2"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          Short answer: Nope! Long answer: HopperHacks is a
                          beginner-friendly hackathon, so please do not feel as
                          if you need to have any coding experience to
                          participate. If you do not know how to code but want
                          to learn and have fun, we have workshops and
                          activities throughout the event for you to attend. We
                          know that hackathons can be intimidating for many
                          first-time hackers, and so we want this to be a
                          learning and fun experience for you to become more
                          comfortable with working with others, developing new
                          skills, and letting your creativity shine under a time
                          constraint.
                        </div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseGeneralQuestion3"
                          className="cursor-pointer hover-text-bold"
                        >
                          What is HopperHacks Bootcamp Week?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseGeneralQuestion3"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          To help students prepare for HopperHacks, we invite
                          WiCS alumni, on-campus organizations, and other
                          industry professionals to host a variety of workshops
                          the week leading up to HopperHacks.
                        </div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseGeneralQuestion4"
                          className="cursor-pointer hover-text-bold"
                        >
                          What's the cost?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseGeneralQuestion4"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          F-R-E-E! There are no upfront cost for Hopperhacks!
                        </div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseGeneralQuestion5"
                          className="cursor-pointer hover-text-bold"
                        >
                          When is HopperHacks?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseGeneralQuestion5"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          HopperHacks will be held on Saturday, Feburary 3rd @
                          10am
                        </div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseGeneralQuestion6"
                          className="cursor-pointer hover-text-bold"
                        >
                          I have more questions!
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseGeneralQuestion6"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          If you have anything you want us to know prior to the
                          event, please feel free to email us at
                          wics@cs.stonybrook.edu. If you have any questions or
                          concerns during the event, you can always chat with us
                          in person or in the Discord channel, and we will do
                          our best to help you!
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mt-md-4 mx-auto">
                  <div>
                    <h2>Registration</h2>
                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseRegistrationQuestion1"
                          className="cursor-pointer hover-text-bold"
                        >
                          Who can attend?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseRegistrationQuestion1"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          We welcome all undergraduate and graduate students,
                          regardless of gender, major and school! Open to coders
                          and designers of all skill levels. Coding experience
                          not required.
                        </div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseRegistrationQuestion2"
                          className="cursor-pointer hover-text-bold"
                        >
                          When is the deadline to register?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseRegistrationQuestion2"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">TBD</div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseRegistrationQuestion3"
                          className="cursor-pointer hover-text-bold"
                        >
                          Do I need to create a Devpost Account?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseRegistrationQuestion3"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          Yes. You will be expected to submit a project on the
                          Devpost platform which means you are required to
                          create an account.
                        </div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseRegistrationQuestion4"
                          className="cursor-pointer hover-text-bold"
                        >
                          Do I have to submit a project to attend?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseRegistrationQuestion4"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          Nope! You are free to attend any of our workshops and
                          events if you would so choose to.
                        </div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseRegistrationQuestion5"
                          className="cursor-pointer hover-text-bold"
                        >
                          How can I be a mentor?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseRegistrationQuestion5"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          You can apply to be a mentor in the HopperHacks
                          application! Please understand that we will not be
                          able to accept everyone to be a mentor!
                        </div>
                      </div>
                    </div>

                    <div>
                      <p>
                        <span
                          style={{ marginLeft: "1rem" }}
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseRegistrationQuestion6"
                          className="cursor-pointer hover-text-bold"
                        >
                          How can I be a volunteers?
                        </span>
                      </p>
                      <div
                        class="collapse"
                        id="collapseRegistrationQuestion6"
                        data-bs-parent="#FAQACCORDION"
                      >
                        <div class="card card-body text-black">
                          You can apply to be a volunteer in the HopperHacks
                          application! Please note that we cannot accept all
                          volunteer applications!
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 col-md-6 mt-md-4 mx-auto">
                  <h2>Tracks</h2>
                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTracksQuestion1"
                        className="cursor-pointer hover-text-bold"
                      >
                        What are the tacks?
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseTracksQuestion1"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        We have six tracks for you to hack in. Each track has
                        it's own judging criteria and style. Winners of tracks
                        will win a prize!
                      </div>
                    </div>
                  </div>

                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTracksQuestion2"
                        className="cursor-pointer hover-text-bold"
                      >
                        How will prizes work?
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseTracksQuestion2"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        You submit a project to ONE track. If that project wins
                        the track, you'll recieve communication from us for
                        instructions on how to redeem your prize!
                      </div>
                    </div>
                  </div>

                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTracksQuestion3"
                        className="cursor-pointer hover-text-bold"
                      >
                        Do I have to enter a track?
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseTracksQuestion3"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        Yes, if you wish to compete in a track. Please note that
                        you can only enter to ONE track. If you enter multiple
                        tacks, one will be assigned to you.
                      </div>
                    </div>
                  </div>

                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTracksQuestion4"
                        className="cursor-pointer hover-text-bold"
                      >
                        Can I enter multiple tracks?
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseTracksQuestion4"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        Unfortunately, we do not accept multiple track
                        submissions.
                      </div>
                    </div>
                  </div>

                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTracksQuestion5"
                        className="cursor-pointer hover-text-bold"
                      >
                        How can I enter the Best Beginner Hack?
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseTracksQuestion5"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        A team must be at least 50% beginner hackers (less than
                        2 hackathons attended.)
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mt-md-4 mx-auto">
                  <h2>Other</h2>
                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOtherQuestion1"
                        className="cursor-pointer hover-text-bold"
                      >
                        How will teams work?
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseOtherQuestion1"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        We typically recommend a team of 3-4 people. You are
                        free to choose whoever is going to be on your team
                        either prior or during the day of the event. You are
                        also free to work on your own. If you are looking for a
                        team, we will have a Discord channel for you to reach
                        out to other participants and form teams that way.
                      </div>
                    </div>
                  </div>

                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOtherQuestion2"
                        className="cursor-pointer hover-text-bold"
                      >
                        How do I come up with an idea for a project?
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseOtherQuestion2"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        Think about what changes you want to bring to the world.
                        Think of any issues you and/or anyone else have faced in
                        the past or are still facing that you want to focus on
                        resolving. You can think of a target audience and a
                        resolution. Once you have a target or a goal to achieve,
                        then you can start brainstorming ways you can approach
                        using the resources available.
                      </div>
                    </div>
                  </div>

                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOtherQuestion3"
                        className="cursor-pointer hover-text-bold"
                      >
                        Can I cross submit (ie: submit my projects to different
                        hackathons)
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseOtherQuestion3"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        Unfortunately, no cross submitting permitted. If a
                        project is cross submitted, then the project will not be
                        considered for judging.
                      </div>
                    </div>
                  </div>

                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOtherQuestion4"
                        className="cursor-pointer hover-text-bold"
                      >
                        Who can be in person? Are there any travel
                        reimburstments?
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseOtherQuestion4"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        All hackers are allowed in person! Please note that we
                        don't have any reimburstments for travel or stay.
                      </div>
                    </div>
                  </div>

                  <div>
                    <p>
                      <span
                        style={{ marginLeft: "1rem" }}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOtherQuestion5"
                        className="cursor-pointer hover-text-bold"
                      >
                        Where is HopperHack?
                      </span>
                    </p>
                    <div
                      class="collapse"
                      id="collapseOtherQuestion5"
                      data-bs-parent="#FAQACCORDION"
                    >
                      <div class="card card-body text-black">
                        HopperHacks will take place in the Alan S. deVries
                        Center across from West Side Dining!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="clouds">
          <img
            src={cloud1}
            alt="Cloud Image"
            className="position-absolute img-fluid rotate-45"
            style={{
              maxWidth: "10%",
              top: 60,
              left: "55%",
              zIndex: -1,
            }}
          />
          <img
            src={cloud2}
            alt="Cloud Image"
            className="position-absolute img-fluid"
            style={{
              maxWidth: "15%",
              top: 420,
              left: -35,
              zIndex: -1,
            }}
          />
        </div>
        <div className="stars">
          <img
            src={stars1}
            alt="Stars"
            className="position-absolute img-fluid"
            style={{
              maxWidth: "100%",
              left: 0,
              top: 0,
              zIndex: -1,
              pointerEvents: "none",
            }}
          />
          <div className="position-absolute" style={{ top: 0 }}>
            <div className="stars-1"></div>
            <div className="stars-2"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default forwardRef(FAQ);
